import { _baseDeleteFetch, _baseGetFetch, _basePostFetch, _basePutFetch, ApiEnum } from './baseFetch'

const path = '/documents'
const documentUploadsLimit = 20

export const getDocuments = async (queryParams, limit) => {
  return _baseGetFetch(`${path}`, { ...queryParams, limit: limit || process.env.REACT_APP_PAGINATION_SIZE }, undefined)
}

export const getTSBDocuments = async (queryParams, limit) => {
  return _baseGetFetch(`${path}/technical-service-bulletins`, { ...queryParams, limit: limit || process.env.REACT_APP_PAGINATION_SIZE }, undefined)
}

export const getDocumentTypes = () => {
  return _baseGetFetch(`${path}/types`, undefined, undefined)
}

export const getDocumentLanguages = async () => {
  return _baseGetFetch(`${path}/languages`, undefined, undefined)
}

export const getTsbDocumentLanguages = async () => {
  return _baseGetFetch(`${path}/technical-service-bulletins/languages`, undefined, undefined)
}

export const getDocumentCategories = () => {
  return _baseGetFetch(`/document-categories`, undefined, ApiEnum.admin)
}

export const getAdminDocumentModels = () => {
  return _baseGetFetch(`${path}/models`, undefined, ApiEnum.admin)
}

export const getDocumentsUpload = async (queryParams) => {
  return _baseGetFetch(`${path}`, { ...queryParams, maxResults: documentUploadsLimit }, ApiEnum.admin)
}

export const postDocument = async (bodyParams) => {
  return _basePostFetch(`${path}`, bodyParams, ApiEnum.admin)
}

export const putDocument = async (documentId, bodyParams) => {
  return _basePutFetch(`${path}/${documentId}`, bodyParams, ApiEnum.admin)
}

export const putDocumentFile = async (documentId, fileId, bodyParams) => {
  return _basePutFetch(`${path}/${documentId}/files/${fileId}`, bodyParams, ApiEnum.admin)
}

export const putDocumentExternalFile = async (documentId, fileId, bodyParams) => {
  return _basePutFetch(`${path}/${documentId}/external-documents/${fileId}`, bodyParams, ApiEnum.admin)
}

export const deleteDocument = async (documentId) => {
  return _baseDeleteFetch(`${path}/${documentId}`, undefined, ApiEnum.admin)
}

export const deleteDocumentFile = async (documentId, fileId) => {
  return _baseDeleteFetch(`${path}/${documentId}/files/${fileId}`, undefined, ApiEnum.admin)
}

export const deleteDocumentExternalFile = async (documentId, fileId) => {
  return _baseDeleteFetch(`${path}/${documentId}/external-documents/${fileId}`, undefined, ApiEnum.admin)
}
